export default __webpack_public_path__ + "locales/lo-LA/ChangeEmailDialog.json?hash=92496b45e1480ca4a806008ec69f1144";